/* eslint-disable react/prop-types */
import React from 'react';

const PageHeaderText = ({ children }) => (
    <h1 className="PageHeaderText vx_text-4">{children}</h1>        
);

export default PageHeaderText;
